import React from 'react';
import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import css from './Sections.module.css';
import img1 from '../../../assets/plumbing.png';
import img2 from '../../../assets/lighting.png';
import img3 from '../../../assets/furniture.png';
import img4 from '../../../assets/textiles.png';
import img5 from '../../../assets/artAndDecor.png';
import img6 from '../../../assets/stones.webp';

function SectionShopByCategory({ intl, useHistoryPush }) {
  const categoryItems = [
    {
      labelId: 'SectionShopByCategory.category.buildingMaterials',
      slug: 'cat-stone-tile',
      image: img1,
    },
    {
      labelId: 'SectionShopByCategory.category.lighting',
      slug: 'cat-lighting',
      image: img2,
    },
    {
      labelId: 'SectionShopByCategory.category.furniture',
      slug: 'cat-furniture',
      image: img3,
    },
    {
      labelId: 'SectionShopByCategory.category.textiles',
      slug: 'cat-textiles',
      image: img4,
    },
    {
      labelId: 'SectionShopByCategory.category.artDecor',
      slug: 'cat-art-decor',
      image: img5,
    },
  ];
  const SliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 5 } },
      { breakpoint: 1300, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className={css.categoryContainer}>
      <div className={css.sectionHead}>
        <h2>{intl.formatMessage({ id: 'SectionShopByCategory.heading' })}</h2>
      </div>
      <div className={css.sectionContent}>
        <div className={css.categorySlider}>
          <Slider {...SliderSettings}>
            {categoryItems.map(({ labelId, slug, image }, index) => (
              <div
                key={index}
                className={css.categoryItem}
                onClick={() => useHistoryPush('SearchPage', {}, { pub_categoryLevel1: slug })}
              >
                <div className={css.categoryImg}>
                  <img src={image} alt="" />
                </div>
                <h5>{intl.formatMessage({ id: labelId })}</h5>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default SectionShopByCategory;
